var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovistarPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 298.88 134.78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144,.68a22.24,22.24,0,0,1,20,4.74c7.76,6.69,11.12,16.8,13.9,26.33a148.4,148.4,0,0,1,2.47,61.73c-.74,4.84-2.29,10-6.31,13.14-3.56,3-9.51,3.06-12.67-.55-2.86-3.39-3.17-8.12-2.79-12.36.86-9.7,2.27-19.4,1.86-29.17-.2-3.62-.64-7.48-2.81-10.51a8.57,8.57,0,0,0-10.41-2.79c-5.71,2.64-9.28,8.22-12.18,13.57-6.54,13-10.21,27.2-14.76,41-2.4,6.92-6.3,13.63-12.4,17.9-7.22,5.06-16.38,6.4-25,6-10.69-.64-20.16-7.5-25.66-16.45-6.33-10.44-12.2-21.16-18.35-31.71-1.85-3-3.76-6.15-6.77-8.1-3.2-2.18-8-.27-9.24,3.28-1.46,3.82-1.11,8.06-.5,12,1.8,10.58,6,20.54,8.46,30.94.89,3.86,1.37,8.34-1,11.77-3.36,4.82-11.26,4.19-14.72-.19S9.88,121.54,8,116.39C1.76,97.91-2.08,78,1.19,58.55,3.26,46.3,6.6,33.43,15.31,24.12c7.24-8,19.66-11,29.53-6.4,5.59,2.77,10,7.46,13.78,12.32,5.32,7.08,10,14.6,14.67,22.13,3.12,5,7.2,9.7,12.73,12a15.18,15.18,0,0,0,16.32-3.07c3.09-2.94,4.78-7,6.36-10.84,4.16-10.31,8.13-20.71,13-30.73C126.07,10.58,134.11,3,144,.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.26 20.87h25.74q0 15.93 0 31.87h31.87v25.76q-15.94 0-31.87 0 0 15.93 0 31.87h-25.75q0-15.95 0-31.87-15.94 0-31.88 0 0-12.89 0-25.75h31.88c0.01-10.63-0.01-21.25 0.01-31.88z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovistarPlus);
export default __webpack_public_path__ + "static/media/Movistar_Plus.2f7023ffec52f7e63af4ac407c718012.svg";
export { ForwardRef as ReactComponent };